import { Action } from '../actions'
import { SHOW_LOADER, HIDE_LOADER } from '../actionTypes'

const initialState = {
  visible: true,
}

// Assign the arrow function to a named constant
const preloaderReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        ...state,
        visible: true,
      }
    case HIDE_LOADER:
      return {
        ...state,
        visible: false,
      }
    default:
      return state
  }
}

// Export the named constant as the default export
export default preloaderReducer
